export default "__VITE_ASSET__DvDnjGJW__"